module.exports = __webpack_public_path__ + "media/images/icons/filled/skype-b41a4b9a519be953f779d4d44e85ebfa.svg";